import { useQuery } from "@apollo/client"
import { Chip } from "@heroui/react"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { ErrorPlaceholder, LoadingPlaceholder, SimplePlaceholder } from "@components"
import { GET_STUDENT_LESSONS } from "@graphql"
import { staffFullname } from "@helpers"
import PropTypes from "prop-types"

const StudentLessonsList = ({ student }) => {
  const { loading, error, data } = useQuery(GET_STUDENT_LESSONS, {
    fetchPolicy: "cache-first",
    variables: {
      id: student.id,
    },
  })

  if (loading) return <LoadingPlaceholder caption="Loading lessons..." icon={CircleStackIcon} />

  if (error) return <ErrorPlaceholder caption="There was an error loading the lessons for this student." error={error} />

  if (data.student.lessons.length === 0) {
    return (
      <SimplePlaceholder isFullHeight={false} icon={CircleStackIcon} title="No lessons found for this student">
        <p className="mt-1 text-sm text-gray-500">
          If you believe this student should have associated lessons then please check your MIS and Xporter integration.
        </p>
      </SimplePlaceholder>
    )
  }

  return (
    <ul className="divide-y divide-gray-300 dark:divide-content2-foreground divide-dotted">
      {data.student.lessons.map(lesson => {
        return (
          <li key={lesson.id} className="flex justify-between py-3">
            {lesson.name} <Chip color="primary">{staffFullname(lesson.teacher)}</Chip>
          </li>
        )
      })}
    </ul>
  )
}

StudentLessonsList.propTypes = {
  student: PropTypes.object.isRequired,
}

export default StudentLessonsList
